export default defineAppConfig({
  ui: {
    colors: {
      primary: 'picton-blue',
      secondary: 'lochmara',
      neutral: 'black',
      success: 'green',
      info: 'blue',
      warning: 'yellow',
      error: 'red',
      gray: 'dove-gray',
      graySecondary: 'chicago',
    },
  },
});
